import { useFormContext } from "react-hook-form";
import { NumberFieldProps } from "./Number.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Input } from "@shadcn/components/ui/input";
import { Label } from "@shadcn/components/ui/label";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";

export const Number = ({ label, name, required, validation, config, disabled }: NumberFieldProps) => {
  const { control } = useFormContext();
  const description = getFieldHelperText(config.helperText, required);
  const validationConfig = getValidationConfig(validation);

  return (
    <FormField
      control={control}
      defaultValue={config.defaultValue}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
      }}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            <Input
              {...field}
              id={name}
              type="number"
              placeholder={config.placeholder}
              max={config.max}
              min={config.min}
              step={config.subType === "float" ? 0.01 : 1}
              disabled={disabled}
              aria-label={label}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};
